// Module
var code = "<ul class=\"multi-level\"> <!-- ko foreach: _processCardsLifeStatuses --> <li> <a data-bind=\"text: $parent.FormatDisplayValue($data), click: $parent.SelectLifeStatus.bind($parent, $data)\" class=\"lookup-dropdown-item\" href=\"#\">1</a> </li> <!-- /ko --> </ul>";
// Exports
export default code;